export default __webpack_public_path__ + "static/media/high-voltage-green.38cf654a.png";